// GLOBAL Consumer
export const objBodyConsumer = (documento: number | string, identifierType: string, profileBusqueda: string, country: string, typeNumber: string) => {
  typeNumber = (typeNumber === undefined || typeNumber === null) ? '' : typeNumber;
  const identifierNumberKey = `IDENTIFIER_NUMBER${typeNumber}`;
  const identifierTypeKey = `IDENTIFIER_TYPE${typeNumber}`;
  return {
    profileId: profileBusqueda,
    consumer: {
      identifiers: {
        IDENTIFIER_ORIGIN_COUNTRY_CODE: country,
        [identifierNumberKey]: documento.toString(),
        [identifierTypeKey]: identifierType
      },
    },
  };
};

// GLOBAL Commercial
export const objBodyCommercial = (documento: number | string, identifierType: string, profileBusqueda: string, country: string, typeNumber: string) => {
  typeNumber = (typeNumber === undefined || typeNumber === null) ? '' : typeNumber;
  const identifierNumberKey = `IDENTIFIER_BUSINESS_ID${typeNumber}`;
  const identifierTypeKey = `IDENTIFIER_BUSINESS_ID_TYPE${typeNumber}`;
  return {
    profileId: profileBusqueda,
    commercial: {
      identifiers: {
        IDENTIFIER_ORIGIN_COUNTRY_CODE: country,
        IDENTIFIER_BUSINESS_COUNTRY: country,
        [identifierNumberKey]: documento.toString(),
        [identifierTypeKey]: identifierType,
      },
    },
  };
};
